var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "create-chatbot-wrapper" },
    [
      _vm.websiteBuilder
        ? _c("WebsiteChatbotBuilder", {
            on: {
              cancel: function () {
                return (_vm.websiteBuilder = false)
              },
            },
          })
        : _c("div", { staticClass: "create-chatbot" }, [
            _c(
              "div",
              { staticClass: "sticky-header" },
              [
                _c("div", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("chatbotv2.setUpYourChatbot"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "description" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("chatbotv2.setUpYourChatbotDesc")) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  {
                    staticClass: "btnCloseCb",
                    attrs: { small: "" },
                    on: { click: _vm.close },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("close"),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "items" }, [
              _c(
                "div",
                {
                  staticClass: "block block-scratch",
                  on: { click: _vm.createBlankStory },
                },
                [
                  _c("div", { staticClass: "icon" }, [
                    _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "name" }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.blankBot"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "description" }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.blankBotDesc"))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "block block-ai",
                  on: { click: _vm.channelNotAvailable },
                },
                [
                  _c("div", { staticClass: "ai-badge" }, [
                    _c("span", { staticClass: "lang" }, [
                      _vm._v("ENGLISH/TURKISH"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("AI")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "icon" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("public"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "name" }, [_vm._v("Website")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "description" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("chatbotv2.websiteDesc")) +
                        "\n                "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "divider-items" }, [
                _c(
                  "div",
                  { staticClass: "half-template-area" },
                  [
                    _c("a-divider", { staticClass: "template-divider" }, [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.readyTemplates"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "half-template-items first" },
                      _vm._l(_vm.getFilteredTemplates(), function (template) {
                        return _c(
                          "div",
                          {
                            staticClass: "block block-ai block-template",
                            on: {
                              click: function ($event) {
                                _vm.selectedTemplate = template
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "ai-badge" }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("chatbotv2.basicTemplate"))
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "icon" }, [
                              _c("img", {
                                attrs: { src: template.imageUrl, alt: "" },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "name" }, [
                              _vm._v(_vm._s(template.name[_vm.currentLang])),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "description" }, [
                              _vm._v(
                                _vm._s(
                                  template.shortDescription[_vm.currentLang]
                                )
                              ),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "half-template-area" },
                  [
                    _c("a-divider", { staticClass: "template-divider" }, [
                      _vm._v(
                        _vm._s(_vm.$t("chatbotv2.templatesFromTheIndustry"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "half-template-items" },
                      _vm._l(_vm.getFilteredAiTemplates(), function (template) {
                        return _c(
                          "div",
                          {
                            staticClass: "block block-ai block-template",
                            on: {
                              click: function ($event) {
                                _vm.selectedTemplate = template
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "ai-badge" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("chatbotv2.proTemplate"))),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "icon" }, [
                              _c("img", {
                                attrs: { src: template.imageUrl, alt: "" },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "name" }, [
                              _vm._v(_vm._s(template.name[_vm.currentLang])),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "description" }, [
                              _vm._v(
                                _vm._s(
                                  template.shortDescription[_vm.currentLang]
                                )
                              ),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
      _vm._v(" "),
      _vm.openAIModal
        ? _c(
            "Modal2",
            {
              staticClass: "open-ai-wrapper",
              attrs: { id: "openAI", showTitle: false, showFooter: false },
              on: {
                cancel: function ($event) {
                  _vm.openAIModal = false
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "open-ai-modal-body" },
                [
                  _c("ApiKeyIcon", {
                    staticStyle: { width: "400px", height: "250px" },
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "open-ai-modal-text" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("chatbotv2.yourNeedEnterYourOpenAi")) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "delete-modal-btn" }, [
                    _c(
                      "button",
                      {
                        staticClass: "push-btn-give-up",
                        on: {
                          click: function ($event) {
                            _vm.openAIModal = false
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("message.cancel")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "push-btn",
                        on: { click: _vm.openAIChannelCreate },
                      },
                      [_vm._v(_vm._s(_vm.$t("chatbotv2.createOpenAiKey")))]
                    ),
                  ]),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedTemplate
        ? _c(
            "a-modal",
            {
              staticClass: "template-modal",
              attrs: {
                centered: "",
                visible: !!_vm.selectedTemplate,
                footer: null,
                closable: true,
              },
              on: {
                cancel: function ($event) {
                  _vm.selectedTemplate = null
                },
              },
            },
            [
              _c("div", { staticClass: "modal-import-template" }, [
                _c("div", { staticClass: "description" }, [
                  _c("div", { staticClass: "top" }, [
                    _c("img", {
                      staticClass: "image",
                      attrs: {
                        src: _vm.selectedTemplate.imageUrl,
                        alt: _vm.selectedTemplate.name,
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "header" },
                      [
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.selectedTemplate.name[_vm.currentLang]
                              ) +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a-button",
                          {
                            attrs: {
                              type: "primary",
                              ghost: "",
                              disbled: _vm.importing,
                              loading: _vm.importing,
                              disabled: !_vm.selectedTemplate.enabled,
                            },
                            on: {
                              click: function () {
                                return _vm.createStory(
                                  _vm.selectedTemplate.slug
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.importing
                                    ? _vm.$t("chatbotv2.importing")
                                    : _vm.$t("chatbotv2.importBot")
                                ) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tpl-markdown description-content" },
                    [
                      _c("p", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.selectedTemplate.description[
                                _vm.currentLang
                              ].split("\n")[0]
                            ) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.selectedTemplate.description[_vm.currentLang].split(
                        "\n"
                      )[3] !== "" && !_vm.isThatAI(_vm.selectedTemplate)
                        ? _c("div", [
                            _c("p", [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.$t("chatbotv2.keyFeatures")) + ":"
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "ul",
                              _vm._l(
                                _vm.$_.drop(
                                  _vm.selectedTemplate.description[
                                    _vm.currentLang
                                  ].split("\n"),
                                  3
                                ),
                                function (keyFeature, index) {
                                  return _c("li", { key: index }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          keyFeature.replace("*", "").trim()
                                        ) +
                                        "\n                            "
                                    ),
                                  ])
                                }
                              ),
                              0
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "details" }, [
                  _c("div", { staticClass: "section" }, [
                    _c("div", { staticClass: "label" }, [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.lastUpdate"))),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "data" }, [
                      _vm._v(
                        _vm._s(_vm.timeHumanize(_vm.selectedTemplate.updatedAt))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "section" }, [
                    _c("div", { staticClass: "label" }, [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.categories"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "data",
                        staticStyle: {
                          "flex-direction": "column",
                          "align-items": "flex-start",
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.selectedTemplate.categories[
                                _vm.currentLang
                              ].join(", ")
                            ) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "section" }, [
                    _vm.$i18n.locale === "en" || _vm.$i18n.locale === "ru"
                      ? _c("div", { staticClass: "label" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("chatbotv2.worksWith")) +
                              "\n                    "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "data",
                        staticStyle: {
                          "flex-direction": "column",
                          "align-items": "flex-start",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "display-integrations" },
                          [
                            _c("img", {
                              staticClass: "icon supsis",
                              attrs: { src: "/static/img/supsis-logo3.png" },
                            }),
                            _vm._v(" "),
                            _c("WhatsappV1", {
                              staticClass: "templates-whatsapp-icon",
                              attrs: { color: "#28AC01" },
                            }),
                            _vm._v(" "),
                            _c("WhatsappV2", {
                              staticClass: "templates-whatsapp-icon",
                              attrs: { color: "#28AC01" },
                            }),
                            _vm._v(" "),
                            _c("WhatsappBusinessIcon", {
                              staticClass: "templates-whatsapp-icon",
                              attrs: { color: "#28AC01" },
                            }),
                            _vm._v(" "),
                            _c("TelegramIcon"),
                            _vm._v(" "),
                            _c("InstagramIcon", {
                              attrs: { "special-background-mode": "" },
                            }),
                            _vm._v(" "),
                            _c("MessengerIcon"),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.$i18n.locale === "tr"
                      ? _c("div", { staticClass: "label" }, [
                          _vm._v(_vm._s(_vm.$t("chatbotv2.worksWith"))),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }